import api from '../services/api';

export const getBudgets = async (year = '') => {
  try {
    const url = year ? `budgets?year=${year}` : `/budgets`;
    const response = await api.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching budgets:', error);
    throw error;
  }
};

export const getBudgetFormData = async () => {
  try {
    const response = await api.get(`budgets/create`);
    return response.data;
  } catch (error) {
    console.error('Error fetching budget form data:', error);
    throw error;
  }
};

export const getBudget = async (id) => {
  try {
    const response = await api.get(`budgets/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching budget:', error);
    throw error;
  }
};

export const getBudgetItems = async (budgetId) => {
  try {
    const response = await api.get(`budgets/${budgetId}/items`);
    return response.data;
  } catch (error) {
    console.error('Error fetching budget items:', error);
    throw error;
  }
};

export const updateItemAllocations = async (budgetId, allocations) => {
  try {
    const formData = new FormData();
    formData.append('allocations', JSON.stringify(allocations));
    
    const response = await api.put(`budgets/${budgetId}/allocations`, formData);
    return response.data;
  } catch (error) {
    console.error('Error updating allocations:', error);
    throw error;
  }
};

export const createBudget = async (budgetData) => {
  try {
    const formData = new FormData();
    Object.keys(budgetData).forEach(key => {
      formData.append(key, budgetData[key]);
    });

    const response = await api.post(`budgets`, formData);
    return response.data;
  } catch (error) {
    console.error('Error creating budget:', error);
    throw error;
  }
};

export const updateBudget = async (id, budgetData) => {
  try {
    const formData = new FormData();
    Object.keys(budgetData).forEach(key => {
      formData.append(key, budgetData[key]);
    });

    const response = await api.put(`budgets/${id}`, formData);
    return response.data;
  } catch (error) {
    console.error('Error updating budget:', error);
    throw error;
  }
};

export const deleteBudget = async (id) => {
  try {
    const response = await api.delete(`budgets/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting budget:', error);
    throw error;
  }
};

export const importBudget = async (importData) => {
  try {
    let formData;
    
    // Check if importData is already FormData
    if (importData instanceof FormData) {
      formData = importData;
    } else {
      // Create FormData from object
      formData = new FormData();
      Object.keys(importData).forEach(key => {
        formData.append(key, importData[key]);
      });
    }

    const response = await api.post(`budgets/import`, formData);
    return response.data;
  } catch (error) {
    console.error('Error importing budget:', error);
    throw error;
  }
};

export const exportBudget = async (filters) => {
  try {
    const response = await api.get(`budgets/export`, {
      params: filters,
      responseType: 'blob'
    });
    
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.download = `budgets_${new Date().toISOString().split('T')[0]}.xlsx`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Error exporting budget:', error);
    throw error;
  }
};

export const downloadTemplate = async () => {
  try {
    const response = await api.get(`budgets/template`, {
      responseType: 'blob'
    });
    
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.download = 'budget_import_template.xlsx';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Error downloading template:', error);
    throw error;
  }
};
